<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px" size="mini">
      <el-form-item label="委托编号" prop="entrustNum">
        <el-input v-model="queryParams.entrustNum" placeholder="请输入委托编号" clearable style="width: 200px" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="识别码" prop="OIDNO">
        <el-input v-model="queryParams.OIDNO" placeholder="请输入识别码" clearable style="width: 200px" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="报告编号" prop="recordNum">
        <el-input v-model="queryParams.recordNum" placeholder="请输入报告编号" clearable style="width: 200px" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 操作按钮区域 -->
    <!-- <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" plain icon="el-icon-view" size="mini" @click="handlePreview">预览</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="warning" plain icon="el-icon-edit-outline" size="mini" @click="handleVerify">校核</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="success" plain icon="el-icon-check" size="mini" @click="handleReview">审核</el-button>
      </el-col>

      <el-col :span="1.5">
        <el-button type="info" plain icon="el-icon-stamp" size="mini" @click="handleIssue">签发</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger" plain icon="el-icon-back" size="mini" @click="handleReturn">退回</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="text" icon="el-icon-search" size="mini" @click="showSearch = !showSearch">
          {{ showSearch ? '隐藏搜索' : '显示搜索' }}
        </el-button>
      </el-col>
    </el-row> -->

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="reviewList" @selection-change="handleSelectionChange" border>
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="委托编号" align="center" prop="entrustNum" />
      <el-table-column label="电梯识别码" align="center" prop="OIDNO" :show-overflow-tooltip="true" />
      <el-table-column label="使用单位名称" align="center" prop="USE_UNT_NAME" :show-overflow-tooltip="true" />
      <el-table-column label="检测人" align="center" prop="inspector" />
      <el-table-column label="检测日期" align="center" prop="inspectionDate" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.inspectionDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="审核人" align="center" prop="reviewer" />
      <el-table-column label="签发人" align="center" prop="issuer" />
      <el-table-column label="报告状态" align="center" prop="status">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">
            {{ scope.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right" width="180">
        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            type="text"
            icon="el-icon-view"
            @click="handlePreviewItem(scope.row)"
            >预览</el-button
          > -->
          <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleReview="handleReview(scope.row)" @handleIssue="handleIssue(scope.row)" @handleReturn="handleReturn(scope.row)" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination v-show="total > 0" :total="total" :page-size="queryParams.pageSize" :current-page="queryParams.currPage" @current-change="getList" />

    <!-- 预览文件弹出层 -->
    <el-dialog title="文件预览" :visible.sync="previewDialogVisible" width="80%" :close-on-click-modal="false" :close-on-press-escape="false" class="preview-dialog">
      <div class="preview-container">
        <div class="preview-header">
          <div class="preview-title">有机房货梯原始记录</div>
          <div class="preview-info">
            <span>委托编号：{{ currentRow ? currentRow.entrustNum : '' }}</span>
            <span>电梯识别码：{{ currentRow ? currentRow.OIDNO : '' }}</span>
          </div>
        </div>
        <div class="preview-content">
          <!-- 文件预览区域 -->
          <iframe :src="'/documents/有机房货梯原始记录(1).docx'" frameborder="0" width="100%" height="500px"></iframe>
          <!-- 如果浏览器不支持直接预览docx，可以显示提示信息 -->
          <div class="preview-fallback">
            <p>当前浏览器可能无法直接预览Word文档，您可以下载后查看</p>
            <el-button type="primary" size="mini" @click="downloadFile">下载文件</el-button>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="warning" @click="handleVerify" icon="el-icon-edit-outline">校核</el-button>
        <el-button type="success" @click="handleReview" icon="el-icon-check">审核</el-button>
        <el-button type="info" @click="handleReturn" icon="el-icon-stamp">退回</el-button>
        <el-button @click="previewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 操作人员选择弹窗 -->
    <el-dialog :title="operatorDialog.title" :visible.sync="operatorDialog.visible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="operatorForm" :model="operatorForm" label-width="80px">
        <el-form-item label="操作人员">
          <el-select v-model="operatorForm.employeePid" placeholder="请选择操作人员" style="width: 100%" clearable>
            <el-option v-for="item in employeeList" :key="item.employeePid" :label="item.employeeName" :value="item.employeePid" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="operatorDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleOperatorConfirm" :loading="operatorDialog.loading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { testDataOperator, queryTestDataAuditApproval, queryEmployeeDropdown } from '@/api/contract/contract';
export default {
  name: 'ReviewIssue',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 预览弹窗显示状态
      previewDialogVisible: false,
      // 当前选中行
      currentRow: null,
      // 表格数据
      reviewList: [],
      // 操作人员弹窗
      operatorDialog: {
        visible: false,
        title: '',
        loading: false,
        optType: '', // Audit, Approval, Back
        currentRow: null
      },
      // 操作人员表单
      operatorForm: {
        employeePid: ''
      },
      // 操作人员列表
      employeeList: [],
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 200,
        entrustNum: undefined,
        OIDNO: undefined,
        recordNum: undefined
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    /** 获取列表数据 */
    getList () {
      this.loading = true
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize
      }

      // 添加搜索条件
      if (this.queryParams.entrustNum) {
        params.entrustNum = this.queryParams.entrustNum
      }
      if (this.queryParams.OIDNO) {
        params.OIDNO = this.queryParams.OIDNO
      }
      if (this.queryParams.recordNum) {
        params.recordNum = this.queryParams.recordNum
      }

      queryTestDataAuditApproval(params).then(response => {
        this.reviewList = response.additionalData.records || []
        this.total = response.total || 0
        this.loading = false
      }).catch(error => {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
        this.loading = false
      })
    },
    /** 获取操作人员列表 */
    getEmployeeList (sginType) {
      const params = {
        configReportPid: this.operatorDialog.currentRow.configReportPid
      }
      if (sginType) {
        params.sginType = sginType
      }

      queryEmployeeDropdown(params).then(response => {
        this.employeeList = response.additionalData || []
      }).catch(error => {
        console.error('获取操作人员列表失败:', error)
        this.$message.error('获取操作人员列表失败')
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.currPage = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams.currPage = 1
      this.queryParams.entrustNum = undefined
      this.queryParams.OIDNO = undefined
      this.queryParams.recordNum = undefined
      this.$refs.queryForm.resetFields()
      this.getList()
    },
    /** 选中行数据 */
    handleSelectionChange (selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    // 获取状态对应的标签类型
    getStatusType (status) {
      switch (status) {
        case '已签发':
          return 'success'
        case '已审核':
          return 'primary'
        case '已校核':
          return 'warning'
        case '待审核':
          return 'info'
        case '待校核':
          return 'info'
        case '待签发':
          return 'warning'
        default:
          return 'info'
      }
    },
    // 批量操作按钮
    handlePreview () {
      if (this.multiple) {
        this.$message.warning('请选择至少一条记录')
        return
      }
      // 设置当前选中行
      this.currentRow = this.reviewList.find(item => item.id === this.ids[0])
      // 显示预览弹窗
      this.previewDialogVisible = true
    },
    /** 校核按钮 */
    handleVerify (row) {
      // if (this.multiple) {
      //   this.$message.warning('请选择至少一条记录')
      //   return
      // }
      // const selectedRow = this.reviewList.find(item => item.id === this.ids[0])
      // this.showOperatorDialog('校核', 'Audit', row.id, 'Audit')
    },
    /** 退回按钮 */
    handleReturn (row) {
      // if (this.multiple) {
      //   this.$message.warning('请选择至少一条记录')
      //   return
      // }
      // const selectedRow = this.reviewList.find(item => item.id === this.ids[0])
      this.showOperatorDialog('退回', 'Back', row.id)
    },
    /** 显示操作人员选择弹窗 */
    showOperatorDialog (title, optType, row, sginType) {
      this.operatorDialog.title = `选择${title}人员`
      this.operatorDialog.optType = optType
      this.operatorDialog.currentRow = row
      this.operatorDialog.visible = true

      // 清空表单
      this.operatorForm.employeePid = ''

      // 获取操作人员列表
      if (sginType) {
        this.getEmployeeList(sginType)
      } else {
        // 退回操作不需要传sginType
        this.getEmployeeList()
      }
    },
    // 单行操作按钮
    handlePreviewItem (row) {
      // 设置当前选中行
      this.currentRow = row
      // 显示预览弹窗
      this.previewDialogVisible = true
    },
    handleReview (row) {
      console.log(row, '审核');

      this.showOperatorDialog('审核', 'Audit', row, 'Approval')
    },
    handleIssue (row) {
      // 直接执行签发操作，不需要选择人员
      this.$confirm('确定要签发此记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 直接调用签发API
        const params = {
          nextEmployeePid: '', // 签发不需要选择下一个操作人员
          id: row.id,
          entrustNum: row.entrustNum,
          optType: 'Approval'
        }

        testDataOperator(params).then(response => {
          this.$message.success('签发操作成功')
          // 刷新列表
          this.getList()
        }).catch(error => {
          console.error('签发失败:', error)
          const errorMessage = error.response?.data?.message || error.message || '签发失败'
          this.$message.error(errorMessage)
        })
      }).catch(() => {
        // 用户取消操作
      })
    },
    /** 操作人员确认 */
    handleOperatorConfirm () {
      // 退回操作不需要选择人员
      // if (this.operatorDialog.optType !== 'Back' && !this.operatorForm.employeePid) {
      //   this.$message.warning('请选择操作人员')
      //   return
      // }

      this.operatorDialog.loading = true

      const params = {
        nextEmployeePid: this.operatorForm.employeePid || '',
        id: this.operatorDialog.currentRow.id || '', // 退回操作可以为空
        entrustNum: this.operatorDialog.currentRow.entrustNum,
        optType: this.operatorDialog.optType
      }

      testDataOperator(params).then(response => {
        this.operatorDialog.loading = false
        this.operatorDialog.visible = false

        // 成功提示
        const optTypeText = {
          'Audit': '审核',
          'Approval': '签发',
          'Back': '退回'
        }
        this.$message.success(`${optTypeText[this.operatorDialog.optType]}操作成功`)

        // 刷新列表
        this.getList()

      }).catch(error => {
        this.operatorDialog.loading = false
        console.error('操作失败:', error)

        // 显示失败原因
        const errorMessage = error.response?.data?.message || error.message || '操作失败'
        this.$message.error(errorMessage)
      })
    },
    // 下载文件
    downloadFile () {
      // 创建一个a标签用于下载
      const link = document.createElement('a')
      link.href = '/documents/有机房货梯原始记录(1).docx'
      link.download = '有机房货梯原始记录.docx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.mb8 {
  margin-bottom: 8px;
}

/* 预览弹出层样式 */
.preview-dialog .el-dialog__body {
  padding: 10px 20px;
}

.preview-container {
  display: flex;
  flex-direction: column;
}

.preview-header {
  margin-bottom: 15px;
  text-align: center;
}

.preview-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.preview-info {
  display: flex;
  justify-content: space-around;
  color: #606266;
  font-size: 14px;
}

.preview-content {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 10px;
  min-height: 500px;
}

.preview-fallback {
  text-align: center;
  margin-top: 20px;
  color: #909399;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
